<template>
    <div>
        <!-- alert modal -->
        <b-modal :id="modalAlert.id"
                 @hidden="onModalAlertHidden()"
                 modal-class="modal-alert"
                 centered
                 hide-header
                 hide-footer
                 no-close-on-backdrop
                 no-close-on-esc>
            <div class="modal-base">
                <div class="modal-base-head">
                    <div class="modal-base-close" @click="clickCloseAddressModal()"></div>
                    <p>{{modalAlert.title}}</p>
                </div>
                <div class="modal-base-body">
                    <p>{{modalAlert.message}}</p>
                </div>
                <div class="modal-base-footer">
                    <button class="btn btn-primary" @click="clickOkModalAlert()">{{modalAlert.strBtnOk}}</button>
                </div>
            </div>
        </b-modal>

        <!-- confirm modal -->
        <b-modal :id="modalConfirm.id"
                 @hidden="onModalConfirmHidden()"
                 modal-class="modal-confirm"
                 centered
                 hide-header
                 hide-footer
                 no-close-on-backdrop
                 no-close-on-esc>
            <div class="modal-base">
                <div class="modal-base-head">
                    <div class="modal-base-close" @click="clickCloseAddressModal()"></div>
                    <p>{{modalConfirm.title}}</p>
                </div>
                <div class="modal-base-body">
                    <p>{{modalConfirm.message}}</p>
                </div>
                <div class="modal-base-footer">
                    <button class="btn btn-secondary" @click="clickCancelModalConfirm()">{{modalConfirm.strBtnCancel}}</button>
                    <button class="btn btn-primary ml-2" @click="clickOkModalConfirm()">{{modalConfirm.strBtnOk}}</button>
                </div>
            </div>
        </b-modal>

        <!-- loading modal -->
        <b-modal :id="modalLoading.id"
                 @hidden="onModalLoadingHidden()"
                 modal-class="modal-loading"
                 centered
                 hide-header
                 hide-footer>
            <div class="modal-loading-content">
                <img src="@/assets/other/loading_new.gif">
            </div>
        </b-modal>
    </div>
</template>
<script>
import Util from '@/helper/Utility.js';

/**
 * @property {string} view require - view unique name
 * @property {Vue} busModal optional - object for control modal
 *
 * Event callback
 * - alert
 * @event modalAlertOk
 * @event modalAlertHidden
 * - confirm
 * @event modalConfirmOk
 * @event modalConfirmCancel
 * @event modalConfirmHidden
 * - loading
 * @event modalLoadingHidden
 *
 * Call function by busModal event
 * - alert
 * @function showAlertModal
 * @function hideAlertModal
 * - confirm
 * @function showConfirmModal
 * @function hideConfirmModal
 * - loading
 * @function showLoadingModal
 * @function hideLoadingModal
 */
export default {
    name: "Modal",
    props: {
        view: String,
        busModal: Object,
    },
    data: function() {
        return {
            modalAlert: {
                id: 'modal-alert-',
                title: '',
                strBtnOk: '',
                message: '',
                tag: '',
            },
            modalConfirm: {
                id: 'modal-confirm-',
                title: '',
                strBtnOk: '',
                strBtnCancel: '',
                message: '',
                tag: '',
            },
            modalLoading: {
                id: 'modal-loading-',
            },
        };
    },
    created: function() {
        this.modalAlert.id += this.view;
        this.modalConfirm.id += this.view;
        this.modalLoading.id += this.view;
    },
    mounted: function() {
        this.busModal.$on('showAlertModal', this.showModalAlert);
        this.busModal.$on('hideAlertModal', this.hideModalAlert);

        this.busModal.$on('showConfirmModal', this.showModalConfirm);
        this.busModal.$on('hideConfirmModal', this.hideModalConfirm);

        this.busModal.$on('showLoadingModal', this.showModalLoading);
        this.busModal.$on('hideLoadingModal', this.hideModalLoading);
    },
    methods: {
        // === modal alert ===
        /**
         * @param {object} config - config modal
         * {
         *      title: '' ,     // Title text modal
         *      message: '',    // Message text modal
         *      strBtnOk: '',   // Button ok text modal (optional)
         *      tag: '',        // String modal tag name (optional)
         * }
         */
        showModalAlert: function(config) {
            this.modalAlert.title = config.title;
            this.modalAlert.message = config.message;
            this.modalAlert.strBtnOk = Util.isEmptyStr(config.strBtnOk) ? 'Ok' : config.strBtnOk;
            this.modalAlert.tag = config.tag;

            this.$bvModal.show(this.modalAlert.id);
        },
        hideModalAlert: function() {
            this.$bvModal.hide(this.modalAlert.id);
        },
        clickOkModalAlert: function() {
            this.hideModalAlert();
            this.$emit('modalAlertOk', { tag: this.modalAlert.tag });
        },
        onModalAlertHidden: function() {
            this.$emit('modalAlertHidden', { tag: this.modalAlert.tag });
        },

        // === modal confirm ===
        /**
         * @param {object} config - config modal
         * {
         *      title: '' ,         // Title text modal
         *      message: '',        // Message text modal
         *      strBtnOk: '',       // Button ok text modal (optional)
         *      strBtnCancel: '',   // Button cancel text modal (optional)
         *      tag: '',            // String modal tag name (optional)
         * }
         */
        showModalConfirm: function(config) {
            this.modalConfirm.title = config.title;
            this.modalConfirm.message = config.message;
            this.modalConfirm.strBtnOk = Util.isEmptyStr(config.strBtnOk) ? 'Ok' : config.strBtnOk;
            this.modalConfirm.strBtnCancel = Util.isEmptyStr(config.strBtnCancel) ? 'Cancel' : config.strBtnCancel;
            this.modalConfirm.tag = config.tag;

            this.$bvModal.show(this.modalConfirm.id);
        },
        hideModalConfirm: function() {
            this.$bvModal.hide(this.modalConfirm.id);
        },
        clickOkModalConfirm: function() {
            this.hideModalConfirm();
            this.$emit('modalConfirmOk', { tag: this.modalConfirm.tag });
        },
        clickCancelModalConfirm: function() {
            this.hideModalConfirm();
            this.$emit('modalConfirmCancel', { tag: this.modalConfirm.tag });
        },
        onModalConfirmHidden: function() {
            this.$emit('modalConfirmHidden', { tag: this.modalConfirm.tag });
        },

        // === modal loading ===
        showModalLoading: function() {
            this.$bvModal.show(this.modalLoading.id);
        },
        hideModalLoading: function() {
            this.$bvModal.hide(this.modalLoading.id);
        },
        onModalLoadingHidden: function() {
            this.$emit('modalLoadingHidden');
        },
    },
}
</script>
<style lang="scss">
@import "@/style/base/component/modal/modal.scss";
</style>
